import SupplierAcceptTaxAuthorityAPI from '@/api/SupplierAcceptTaxAuthorityAPI.js';
import httpClient from '../../api/axios-httpclient';
import commonFunc from '@/common/commonFunction';

export default {
	/**
	 * Lấy danh sách các NCC thiết lập chấp nhận bỏ qua tồn tại CQT
	 */
	getSupplierAcceptTaxAuthoritiesAsync: async function(context, payload) {
		let res = await httpClient.getAsync(
			{
				url: SupplierAcceptTaxAuthorityAPI.getAPIUrlSubParam(commonFunc.getSubParam()),
				params: payload
			},
			true
		);
		if (res && res.Data) {
			let result = res.Data;
			context.commit('updateSupplierAcceptTaxAuthorities', result.Data);
			return res.Data;
		}
		return res;
	},

	/**
	 * Thông tin chi tiết  NCC thiết lập chấp nhận bỏ qua tồn tại CQT
	 */
	getSupplierAcceptTaxAuthorityAsync: async function(context, payload) {
		let res = await httpClient.getAsync({
			url: SupplierAcceptTaxAuthorityAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/${payload.OrgReceiveId}`
		});
		if (res && res.Data) {
			context.commit('updateSupplierAcceptTaxAuthority', res.Data);
		}
	},

	/**
	 * Thêm mới thông tin NCC thiết lập chấp nhận bỏ qua tồn tại CQT
	 */
	insertSupplierAcceptTaxAuthorityAsync: async function(context, payload) {
		let res = await httpClient.postAsync({
			url: SupplierAcceptTaxAuthorityAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/insert`,
			data: payload
		});
		return res;
	},

	/**
	 * Cập nhật thông tin NCC thiết lập chấp nhận bỏ qua tồn tại CQT
	 */
	updateSupplierAcceptTaxAuthorityAsync: async function(context, payload) {
		let res = await httpClient.postAsync({
			url: SupplierAcceptTaxAuthorityAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/update`,
			data: payload
		});
		return res;
	},

	/**
	 * Xóa thông tin NCC thiết lập chấp nhận bỏ qua tồn tại CQT
	 */
	deleteSupplierAcceptTaxAuthorityAsync: async function(context, payload) {
		let res = await httpClient.getAsync({
			url: SupplierAcceptTaxAuthorityAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/delete/${payload.id}`
		});
		return res;
	},

	getTotalPageAsync: async function(context, payload) {
		let res = await httpClient.postAsync({
			url: SupplierAcceptTaxAuthorityAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/total`,
			data: payload
		});

		if (res && res.Success) {
			context.commit('updateTotalPage', res.Data);
		}
		return 0;
	}
};
